// removed by extract-text-webpack-plugin
module.exports = {"root":"Results__root___243wg","name":"Results__name___cOOWH"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/interaction/children/quiz/children/results/Results.scss
// module id = 790
// module chunks = 0